"use client";
import { useGlobalContent } from "@app/[locale]/GlobalContentProvider";
import { SubNavigation } from "@components/cms/sub-navigation/SubNavigation";
import type { IPageEditorial } from "@contentful-api/types/contentful";
import { mapButtons } from "@lib/contentful/mappers/parts/button/mapButton";
import { ModulesRenderer } from "@lib/contentful/modules-renderer/ModulesRenderer";
import dynamic from "next/dynamic";

const Headline = dynamic(() =>
    import("@components/cms/headline/Headline").then((mod) => mod.Headline)
);

export interface EditorialLayoutProps {
    page: IPageEditorial;
}

export const EditorialLayout = ({ page }: EditorialLayoutProps) => {
    const { siteSettings } = useGlobalContent();
    const {
        fields: {
            modules,
            title,
            titleSize,
            desc,
            descriptionSize,
            callToActions,
            subNavigationLinksCollection,
        } = {},
    } = page;
    const authorizationInvitation = siteSettings.auth.authorizationInvitation;

    return (
        <>
            {(title || desc) && (
                <Headline
                    title={title}
                    titleSize={titleSize}
                    description={desc}
                    descriptionSize={descriptionSize}
                    callToActions={mapButtons(callToActions)}
                    isModule={false}
                />
            )}
            <SubNavigation linksCollection={subNavigationLinksCollection} />
            <ModulesRenderer modules={modules} authorizationInvitation={authorizationInvitation} />
        </>
    );
};
